import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { setAlert } from "../../action/alert";
import CreateDealer from "./createDealer";
import GetDealerInfo from "./getDealerInfo";
import UploadPSNDealerMapping from "./uploadPSNDealerMapping";
import { uploadPSNDealerFile } from "../../action/deviceDealer";
import customConfig from "../../config";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import { Box } from "@mui/material";
import AppTabs from "../../components/Common/Tabs/AppTabs";
import Alert from "../layout/Alert";

const DeviceDealerMgmt = ({
  wrapperClass,
  allowedDeviceCategories,
  allowedCompanyBrand,
  allowedCountries,
  setAlert,
  deviceDealer,
  uploadPSNDealerFile,
  userRoleInfo,
}) => {
  const [activeTab, setActiveTab] = React.useState(0);
  const [deviceDealerDetails, setDeviceDealerDetails] = useState({});
  const [editDeviceDealerDetails, setEditDeviceDealerDetails] = useState(false);

  const [showUpdatedDealerInfo, setShowUpdatedDealerInfo] = useState(false);

  const isAdmin =
    userRoleInfo.level > 4 ||
    userRoleInfo.roles.includes(customConfig.roleCloudAdmin);

  useEffect(() => {
    if (activeTab !== 0) {
      setEditDeviceDealerDetails(false);
      setDeviceDealerDetails({});
    }
  }, [activeTab]);

  function handleEditDeviceDealerDetails(deviceDealerDetails) {
    setDeviceDealerDetails(deviceDealerDetails);
    setEditDeviceDealerDetails(true);
    setActiveTab(0);
    setShowUpdatedDealerInfo(false);
  }

  function handleCancelEditDeviceDealerDetails() {
    setActiveTab(1); // get back to details page
    setEditDeviceDealerDetails(false);
    setDeviceDealerDetails({});
    setShowUpdatedDealerInfo(true);
  }

  const tabs = isAdmin
    ? [
        { label: "Create Dealer", value: 0 },
        { label: "Get Dealer Information", value: 1 },
        { label: "Upload PSN Dealer Mapping", value: 2 },
      ]
    : [{ label: "Get Dealer Information", value: 0 }];

  return (
    <ResponsiveContentWrapper className={wrapperClass || ""}>
      <Alert />
      <Box sx={{ width: "100%", minWidth: 0, marginBottom: "5px" }}>
        <AppTabs
          tabs={tabs}
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          tabMinWidth="auto"
          tabsSx={{
            mb: 2,
            "& .MuiTabs-flexContainer": {
              gap: 1,
            },
          }}
        />

        {isAdmin ? (
          <Fragment>
            <Box hidden={activeTab !== 0}>
              <CreateDealer
                allowedDeviceCategories={allowedDeviceCategories}
                allowedCompanyBrand={allowedCompanyBrand}
                allowedCountries={allowedCountries}
                setAlert={setAlert}
                editDeviceDealerDetails={editDeviceDealerDetails}
                deviceDealerDetails={deviceDealerDetails}
                cancelEditDeviceDealerDetails={
                  handleCancelEditDeviceDealerDetails
                }
              />
            </Box>

            <Box hidden={activeTab !== 1}>
              <GetDealerInfo
                allowedDeviceCategories={allowedDeviceCategories}
                allowedCompanyBrand={allowedCompanyBrand}
                allowedCountries={allowedCountries}
                setAlert={setAlert}
                onEditDeviceDealerDetails={handleEditDeviceDealerDetails}
                showUpdatedDealerInfo={showUpdatedDealerInfo}
                userRoleInfo={userRoleInfo}
              />
            </Box>

            <Box hidden={activeTab !== 2}>
              <UploadPSNDealerMapping
                allowedDeviceCategories={allowedDeviceCategories}
                allowedCompanyBrand={allowedCompanyBrand}
                allowedCountries={allowedCountries}
                setAlert={setAlert}
                deviceDealer={deviceDealer}
                uploadPSNDealerFile={uploadPSNDealerFile}
              />
            </Box>
          </Fragment>
        ) : (
          <Fragment>
            <Box hidden={activeTab !== 0}>
              <GetDealerInfo
                allowedDeviceCategories={allowedDeviceCategories}
                allowedCompanyBrand={allowedCompanyBrand}
                allowedCountries={allowedCountries}
                setAlert={setAlert}
                onEditDeviceDealerDetails={handleEditDeviceDealerDetails}
                showUpdatedDealerInfo={showUpdatedDealerInfo}
                userRoleInfo={userRoleInfo}
              />
            </Box>
          </Fragment>
        )}
      </Box>
    </ResponsiveContentWrapper>
  );
};

const mapStateToProps = (state) => ({
  allowedDeviceCategories: state.auth.allowedDeviceCategories,
  allowedCompanyBrand: state.auth.allowCompanyBrand,
  allowedCountries: state.auth.allowedCountries,
  deviceDealer: state.deviceDealer,
  userRoleInfo: {
    level: state.auth.userLevel,
    roles: state.auth.userRoles,
  },
});

const mapDispatchToProps = (dispatch) => ({
  setAlert: (message, status) => dispatch(setAlert(message, status)),
  uploadPSNDealerFile: (formData) => dispatch(uploadPSNDealerFile(formData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeviceDealerMgmt);
